export const environment = {
  server_url: "/server/",
  viewer_url: "/viewer/",
  repo_url: "/",
};
